<template>
  <div class="relative" ref="target">
    <div :class="headClass" @click.stop="toggleShow" class="select-none">
      <slot name="head" v-bind="{ show }"></slot>
    </div>

    <Transition name="profile">
      <div
        v-if="show"
        @click.stop="toggleShow"
        :class="wrapperClass"
        class="absolute right-0 w-max min-w-full bg-white rounded-2xl overflow-hidden z-10 dropdown-shadow top-[calc(100%+12px)] cursor-pointer"
      >
        <div :class="bodyClass">
          <slot :data="{ show }" />
        </div>
        <slot name="actions" />
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";

import { TClassName } from "@/types/common";

interface Props {
  headClass?: TClassName;
  bodyClass?: TClassName;
  wrapperClass?: TClassName;
  above?: boolean;
}
defineProps<Props>();

interface Emits {
  (event: "toggle", value: boolean): void;
}
const emit = defineEmits<Emits>();

const show = ref(false);

function toggleShow() {
  show.value = !show.value;
  emit("toggle", show.value);
}

const target = ref();
onClickOutside(target, () => {
  show.value = false;
});
</script>
<style>
.dropdown-shadow {
  box-shadow:
    0 0 14px -4px rgba(0, 0, 0, 0.05),
    0 32px 48px -8px rgba(0, 0, 0, 0.1);
}
</style>
